// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const CreatorPayoutControlLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.creatorPayoutControlLabel"
        description="Creator payout control label."
        defaultMessage="Top Performer Payouts Program"
    />
);
CreatorPayoutControlLabel.displayName = "CreatorPayoutControlLabel";

export const CannotEnableForLensPlusPayouts = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.cannotEnableForLensPlusPayouts"
        description="Cannot enable for lens plus payouts."
        defaultMessage="Cannot enroll in Lens+ Payouts"
    />
);
CannotEnableForLensPlusPayouts.displayName = "CannotEnableForLensPlusPayouts";

export const InvalidLensForLensPlusPayouts = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.invalidLensForLensPlusPayouts"
        description="Invalid lens for lens plus payouts."
        defaultMessage="Invalid Lens for Lens+ Payouts"
    />
);
InvalidLensForLensPlusPayouts.displayName = "InvalidLensForLensPlusPayouts";

export const InvalidLensForLensPlusPayoutsDescription = (props: {
    validationErrorMessage: ReactNode;
}): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.invalidLensForLensPlusPayoutsDescription"
        description="Invalid lens for lens plus payouts description."
        defaultMessage="This Lens is enrolled in Lens+ Payouts but does not meet the requirements: {validationErrorMessage}. Please update your Lens to conform to Lens+ Payouts requirements."
        values={props}
    />
);
InvalidLensForLensPlusPayoutsDescription.displayName = "InvalidLensForLensPlusPayoutsDescription";

export const CreatorPayoutControlTooltipText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.creatorPayoutControlTooltipText"
        description="Creator payout control tooltip text."
        defaultMessage="The Top Performer Payouts Program allows you to earn money based upon engagement on the Lenses you build."
    />
);
CreatorPayoutControlTooltipText.displayName = "CreatorPayoutControlTooltipText";

export const CreatorPayoutControlTooltipLinkText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.creatorPayoutControlTooltipLinkText"
        description="Creator payout control tooltip link text."
        defaultMessage="Learn More"
    />
);
CreatorPayoutControlTooltipLinkText.displayName = "CreatorPayoutControlTooltipLinkText";

export const OwnerMismatchAlertTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.ownerMismatchAlertTitle"
        description="Owner mismatch alert title."
        defaultMessage="Ineligible for the Top Performer Payouts Program"
    />
);
OwnerMismatchAlertTitle.displayName = "OwnerMismatchAlertTitle";

export const OwnerMismatchAlertDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.ownerMismatchAlertDescription"
        description="Owner mismatch alert description."
        defaultMessage="Unfortunately, you do not have permissions to enroll this Lens into the Top Performer Payouts Program."
    />
);
OwnerMismatchAlertDescription.displayName = "OwnerMismatchAlertDescription";

export const TosModalHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.tosModalHeader"
        description="Tos modal header."
        defaultMessage="Snap Lens Creator Rewards Program Terms"
    />
);
TosModalHeader.displayName = "TosModalHeader";

export const TextOutdatedTosWarning = (props: { tosLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.textOutdatedTosWarning"
        description="Text outdated tos warning."
        defaultMessage="We've updated the {tosLink}. You'll need to read and accept the updated Lens Creator Rewards Program Terms in order to enroll the Lens."
        values={props}
    />
);
TextOutdatedTosWarning.displayName = "TextOutdatedTosWarning";

export const TextAcceptedTos = (props: {
    lensPlusPayoutsTermsLink: ReactNode;
    topPerformerPayoutsTermsLink: ReactNode;
}): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.textAcceptedTos"
        description="Text accepted tos."
        defaultMessage="You have accepted the {lensPlusPayoutsTermsLink} and the {topPerformerPayoutsTermsLink}."
        values={props}
    />
);
TextAcceptedTos.displayName = "TextAcceptedTos";

export const TextAcceptedLCRTosLink = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.textAcceptedLCRTosLink"
        description="Text accepted lcr tos link."
        defaultMessage="Snap Lens Creator Rewards Program Terms"
    />
);
TextAcceptedLCRTosLink.displayName = "TextAcceptedLCRTosLink";

export const TextAcceptedLensPlusTOS = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.textAcceptedLensPlusTOS"
        description="Text accepted lens plus to s."
        defaultMessage="Lens+ Payout Program Terms"
    />
);
TextAcceptedLensPlusTOS.displayName = "TextAcceptedLensPlusTOS";

export const LensAutomationToolAlertTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensAutomationToolAlertTitle"
        description="Lens automation tool alert title."
        defaultMessage="Lens Review Service Outage"
    />
);
LensAutomationToolAlertTitle.displayName = "LensAutomationToolAlertTitle";

export const LensAutomationToolAlertDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensAutomationToolAlertDescription"
        description="Lens automation tool alert description."
        defaultMessage="We are currently experiencing an outage with our lens review service. It may take longer than usual to process a lens if it was recently submitted for review."
    />
);
LensAutomationToolAlertDescription.displayName = "LensAutomationToolAlertDescription";

export const CreatorPayoutSubheader = (props: { learnMoreLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.creatorPayoutSubheader"
        description="Creator payout subheader."
        defaultMessage="Become eligible to receive a payout if your Lens becomes a Top Performer. Enrollment does not guarantee payout. {learnMoreLink}"
        values={props}
    />
);
CreatorPayoutSubheader.displayName = "CreatorPayoutSubheader";

export const ExclusiveLensHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.exclusiveLensHeader"
        description="Exclusive lens header."
        defaultMessage="Lens+ Payouts"
    />
);
ExclusiveLensHeader.displayName = "ExclusiveLensHeader";

export const ExclusiveLensSubheader = (props: { learnMoreLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.exclusiveLensSubheader"
        description="Exclusive lens subheader."
        defaultMessage="Your Lens may be made Exclusive to Lens+ subscribers and eligible to receive a payout. Enrollment does not guarantee payout. {learnMoreLink}"
        values={props}
    />
);
ExclusiveLensSubheader.displayName = "ExclusiveLensSubheader";

export const LearnMore = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.learnMore"
        description="Learn more."
        defaultMessage="Learn more"
    />
);
LearnMore.displayName = "LearnMore";

export const LensPlusPayoutsPending = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusPayoutsPending"
        description="Lens plus payouts pending."
        defaultMessage="Lens+ Payouts Pending"
    />
);
LensPlusPayoutsPending.displayName = "LensPlusPayoutsPending";

export const LensPlusPayoutsPendingDescription = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusPayoutsPendingDescription"
        description="Lens plus payouts pending description."
        defaultMessage="Your Lens is pending approval for Lens+ Payouts."
    />
);
LensPlusPayoutsPendingDescription.displayName = "LensPlusPayoutsPendingDescription";

export const LensPlusRemovedTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusRemovedTitle"
        description="Lens plus removed title."
        defaultMessage="Removed from Lens+ Program"
    />
);
LensPlusRemovedTitle.displayName = "LensPlusRemovedTitle";

export const LensPlusRemovedWarning = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusRemovedWarning"
        description="Lens plus removed warning."
        defaultMessage="This Lens did not meet the minimum threshold and has been removed from the Lens+ Program. It is no longer eligible for Lens+ payouts."
    />
);
LensPlusRemovedWarning.displayName = "LensPlusRemovedWarning";

export const ExclusiveLensToggleTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.exclusiveLensToggleTooltip"
        description="Exclusive lens toggle tooltip."
        defaultMessage="Please note it may take up to 72 hours for your Lens to be made Exclusive in Snapchat."
    />
);
ExclusiveLensToggleTooltip.displayName = "ExclusiveLensToggleTooltip";

export const LensPlusPayoutsApplyDescription = (props: { learnMoreLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusPayoutsApplyDescription"
        description="Lens plus payouts apply description."
        defaultMessage="Your Lens may be made Exclusive to Lens+ subscribers and eligible to receive a payout. {learnMoreLink}"
        values={props}
    />
);
LensPlusPayoutsApplyDescription.displayName = "LensPlusPayoutsApplyDescription";

export const TotalPayout = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalPayout"
        description="Total payout."
        defaultMessage="Total Payout"
    />
);
TotalPayout.displayName = "TotalPayout";

export const LastPayoutDate = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lastPayoutDate"
        description="Last payout date."
        defaultMessage="Last Payout Date"
    />
);
LastPayoutDate.displayName = "LastPayoutDate";

export const PayoutDataError = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.payoutDataError"
        description="Payout data error."
        defaultMessage="Payout data is temporarily unavailable. Please try again later."
    />
);
PayoutDataError.displayName = "PayoutDataError";

export const NoPayoutIssued = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.noPayoutIssued"
        description="No payout issued."
        defaultMessage="No Payout Issued"
    />
);
NoPayoutIssued.displayName = "NoPayoutIssued";

export const LatestPayout = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.latestPayout"
        description="Latest payout."
        defaultMessage="Latest payout"
    />
);
LatestPayout.displayName = "LatestPayout";

export const TotalEarned = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalEarned"
        description="Total earned."
        defaultMessage="Total earned"
    />
);
TotalEarned.displayName = "TotalEarned";

export const TotalLensPlusSubscriberActions = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalLensPlusSubscriberActions"
        description="Total lens plus subscriber actions."
        defaultMessage="Lens+ Users"
    />
);
TotalLensPlusSubscriberActions.displayName = "TotalLensPlusSubscriberActions";

export const TotalLensPlusSubscriberActionsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalLensPlusSubscriberActionsTooltip"
        description="Total lens plus subscriber actions tooltip."
        defaultMessage="The number of Lens+ subscribers who sent, posted, or played your Lens. The more they interact with it, the more you earn."
    />
);
TotalLensPlusSubscriberActionsTooltip.displayName = "TotalLensPlusSubscriberActionsTooltip";

export const TotalLensPlusSubscriberActionsTooltipMeta = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalLensPlusSubscriberActionsTooltipMeta"
        description="Total lens plus subscriber actions tooltip meta."
        defaultMessage="Used in payout formula · Data starting from April 1, 2026"
    />
);
TotalLensPlusSubscriberActionsTooltipMeta.displayName = "TotalLensPlusSubscriberActionsTooltipMeta";

export const AllTime = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.allTime"
        description="All time."
        defaultMessage="All time"
    />
);
AllTime.displayName = "AllTime";

export const PayoutHistory = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.payoutHistory"
        description="Payout history."
        defaultMessage="Payout History"
    />
);
PayoutHistory.displayName = "PayoutHistory";

export const MonthPayout = (props: { month: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.monthPayout"
        description="Month payout."
        defaultMessage="{month} payout"
        values={props}
    />
);
MonthPayout.displayName = "MonthPayout";

export const PayoutFooterDisclaimer = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.payoutFooterDisclaimer"
        description="Payout footer disclaimer."
        defaultMessage="Payouts are processed monthly. Enrollment does not guarantee payout."
    />
);
PayoutFooterDisclaimer.displayName = "PayoutFooterDisclaimer";

export const LensInsightsNote = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensInsightsNote"
        description="Lens insights note."
        defaultMessage="These are total interactions (includes repeats by the same user) by all Snapchatters. Lens+ Payouts are based on Lens+ subscribers' actions only."
    />
);
LensInsightsNote.displayName = "LensInsightsNote";

export const LensCreatorRewardsHeading = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensCreatorRewardsHeading"
        description="Lens creator rewards heading."
        defaultMessage="Lens Creator Rewards"
    />
);
LensCreatorRewardsHeading.displayName = "LensCreatorRewardsHeading";

export const ViewFullHistory = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.viewFullHistory"
        description="View full history."
        defaultMessage="View Full History"
    />
);
ViewFullHistory.displayName = "ViewFullHistory";

export const PayoutDriversHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.payoutDriversHeader"
        description="Payout drivers header."
        defaultMessage="PAYOUT DRIVERS"
    />
);
PayoutDriversHeader.displayName = "PayoutDriversHeader";

export const PayoutDriversSubtitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.payoutDriversSubtitle"
        description="Payout drivers subtitle."
        defaultMessage="These numbers affect how much you earn."
    />
);
PayoutDriversSubtitle.displayName = "PayoutDriversSubtitle";

export const HowPayoutsWork = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWork"
        description="How payouts work."
        defaultMessage="How earnings work"
    />
);
HowPayoutsWork.displayName = "HowPayoutsWork";

export const TotalLensPlusAudience = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalLensPlusAudience"
        description="Total lens plus audience."
        defaultMessage="Lens+ Users"
    />
);
TotalLensPlusAudience.displayName = "TotalLensPlusAudience";

export const TotalLensPlusAudienceTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalLensPlusAudienceTooltip"
        description="Total lens plus audience tooltip."
        defaultMessage="The number of Lens+ subscribers who sent, posted, or played your Lens. The more they interact with it, the more you earn."
    />
);
TotalLensPlusAudienceTooltip.displayName = "TotalLensPlusAudienceTooltip";

export const LensPlusSubscriptionsEarned = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusSubscriptionsEarned"
        description="Lens plus subscriptions earned."
        defaultMessage="Lens+ Signups"
    />
);
LensPlusSubscriptionsEarned.displayName = "LensPlusSubscriptionsEarned";

export const LensPlusSubscriptionsEarnedTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusSubscriptionsEarnedTooltip"
        description="Lens plus subscriptions earned tooltip."
        defaultMessage="People who started a Lens+ subscription right after trying your Lens. Each new subscriber increases your earnings."
    />
);
LensPlusSubscriptionsEarnedTooltip.displayName = "LensPlusSubscriptionsEarnedTooltip";

export const LensPlusScore = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusScore"
        description="Lens plus score."
        defaultMessage="Payout Score"
    />
);
LensPlusScore.displayName = "LensPlusScore";

export const LensPlusScoreTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.lensPlusScoreTooltip"
        description="Lens plus score tooltip."
        defaultMessage="Your score is based on your Lens+ Users and Lens+ Signups. A higher score means a larger share of earnings."
    />
);
LensPlusScoreTooltip.displayName = "LensPlusScoreTooltip";

export const TotalPayoutsLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalPayoutsLabel"
        description="Total payouts label."
        defaultMessage="Earnings"
    />
);
TotalPayoutsLabel.displayName = "TotalPayoutsLabel";

export const TotalPayoutsTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.totalPayoutsTooltip"
        description="Total payouts tooltip."
        defaultMessage="The total amount you have been paid for the selected time period."
    />
);
TotalPayoutsTooltip.displayName = "TotalPayoutsTooltip";

export const HowPayoutsWorkModalTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkModalTitle"
        description="How payouts work modal title."
        defaultMessage="What determines your earnings"
    />
);
HowPayoutsWorkModalTitle.displayName = "HowPayoutsWorkModalTitle";

export const HowPayoutsWorkModalIntro = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkModalIntro"
        description="How payouts work modal intro."
        defaultMessage="You earn money based on two things: how many Lens+ subscribers use your Lens, and how many new subscribers your Lens brings in. We combine these into your Payout Score. Reach, Plays, and Shares help people find your Lens, but they do not affect your earnings."
    />
);
HowPayoutsWorkModalIntro.displayName = "HowPayoutsWorkModalIntro";

export const HowPayoutsWorkAudienceTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkAudienceTitle"
        description="How payouts work audience title."
        defaultMessage="Lens+ Users"
    />
);
HowPayoutsWorkAudienceTitle.displayName = "HowPayoutsWorkAudienceTitle";

export const HowPayoutsWorkAudienceBody = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkAudienceBody"
        description="How payouts work audience body."
        defaultMessage="The number of unique Lens+ subscribers who sent, posted, or played your Lens. More unique users means higher earnings."
    />
);
HowPayoutsWorkAudienceBody.displayName = "HowPayoutsWorkAudienceBody";

export const HowPayoutsWorkAudienceExample = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkAudienceExample"
        description="How payouts work audience example."
        defaultMessage="e.g. 82 Lens+ subscribers interacted with your Lens this month"
    />
);
HowPayoutsWorkAudienceExample.displayName = "HowPayoutsWorkAudienceExample";

export const HowPayoutsWorkSubscriptionsTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkSubscriptionsTitle"
        description="How payouts work subscriptions title."
        defaultMessage="Lens+ Signups"
    />
);
HowPayoutsWorkSubscriptionsTitle.displayName = "HowPayoutsWorkSubscriptionsTitle";

export const HowPayoutsWorkSubscriptionsBody = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkSubscriptionsBody"
        description="How payouts work subscriptions body."
        defaultMessage="People who subscribed to Lens+ right after trying your Lens. Each one increases your earnings."
    />
);
HowPayoutsWorkSubscriptionsBody.displayName = "HowPayoutsWorkSubscriptionsBody";

export const HowPayoutsWorkSubscriptionsExample = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkSubscriptionsExample"
        description="How payouts work subscriptions example."
        defaultMessage="e.g. 12 people subscribed after trying your Lens"
    />
);
HowPayoutsWorkSubscriptionsExample.displayName = "HowPayoutsWorkSubscriptionsExample";

export const HowPayoutsWorkScoreTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkScoreTitle"
        description="How payouts work score title."
        defaultMessage="Payout Score"
    />
);
HowPayoutsWorkScoreTitle.displayName = "HowPayoutsWorkScoreTitle";

export const HowPayoutsWorkScoreBody = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkScoreBody"
        description="How payouts work score body."
        defaultMessage="Your score combines Lens+ Users and Lens+ Signups. A higher score means higher earnings."
    />
);
HowPayoutsWorkScoreBody.displayName = "HowPayoutsWorkScoreBody";

export const HowPayoutsWorkScoreExample = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkScoreExample"
        description="How payouts work score example."
        defaultMessage="e.g. your score was 740 this month"
    />
);
HowPayoutsWorkScoreExample.displayName = "HowPayoutsWorkScoreExample";

export const HowPayoutsWorkTipLabel = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkTipLabel"
        description="How payouts work tip label."
        defaultMessage="To earn more:"
    />
);
HowPayoutsWorkTipLabel.displayName = "HowPayoutsWorkTipLabel";

export const HowPayoutsWorkTipBody = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkTipBody"
        description="How payouts work tip body."
        defaultMessage="Make Lenses that Lens+ subscribers love. When non-subscribers try your Lens and sign up, your Payout Score goes up — and so do your earnings."
    />
);
HowPayoutsWorkTipBody.displayName = "HowPayoutsWorkTipBody";

export const HowPayoutsWorkEyebrow = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkEyebrow"
        description="How payouts work eyebrow."
        defaultMessage="HOW EARNINGS WORK"
    />
);
HowPayoutsWorkEyebrow.displayName = "HowPayoutsWorkEyebrow";

export const HowPayoutsWorkReadFullGuidelines = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkReadFullGuidelines"
        description="How payouts work read full guidelines."
        defaultMessage="Read full guidelines"
    />
);
HowPayoutsWorkReadFullGuidelines.displayName = "HowPayoutsWorkReadFullGuidelines";

export const HowPayoutsWorkGotIt = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.howPayoutsWorkGotIt"
        description="How payouts work got it."
        defaultMessage="Got it"
    />
);
HowPayoutsWorkGotIt.displayName = "HowPayoutsWorkGotIt";

export const PayoutDriversStatsVsPrevious = (props: { days: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.payoutDriversStatsVsPrevious"
        description="Payout drivers stats vs previous."
        defaultMessage="vs previous {days} days"
        values={props}
    />
);
PayoutDriversStatsVsPrevious.displayName = "PayoutDriversStatsVsPrevious";

export const PhoneVerificationTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.phoneVerificationTitle"
        description="Phone verification title."
        defaultMessage="Verify your phone number"
    />
);
PhoneVerificationTitle.displayName = "PhoneVerificationTitle";

export const PhoneVerificationBody = (props: { supportLink: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.phoneVerificationBody"
        description="Phone verification body."
        defaultMessage="You must have a verified phone number in order to submit a Lens to Lens+. Follow the link to the support page {supportLink} for instructions on how to verify your phone number on Snapchat. Once verified, turn Lens+ back on to continue."
        values={props}
    />
);
PhoneVerificationBody.displayName = "PhoneVerificationBody";

export const PhoneVerificationSupportLink = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.phoneVerificationSupportLink"
        description="Phone verification support link."
        defaultMessage="here"
    />
);
PhoneVerificationSupportLink.displayName = "PhoneVerificationSupportLink";

export const PhoneVerificationContinue = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCreatorPayout.components.phoneVerificationContinue"
        description="Phone verification continue."
        defaultMessage="Continue"
    />
);
PhoneVerificationContinue.displayName = "PhoneVerificationContinue";
